(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["social-share-icons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const copyButtons = document.querySelectorAll('.social-share-icons__button--copy');

    copyButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        const url = this.dataset.shareUrl;

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard
            .writeText(url)
            .then(() => {
              showCopyFeedback(this);
            })
            .catch(() => {
              fallbackCopyToClipboard(url, this);
            });
        } else {
          fallbackCopyToClipboard(url, this);
        }
      });
    });

    function fallbackCopyToClipboard(text, button) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        showCopyFeedback(button);
      } catch (err) {
        console.error('Failed to copy: ', err);
      } finally {
        textArea.remove();
      }
    }

    function showCopyFeedback(button) {
      const originalIcon = button.querySelector('.social-share-icons__icon').innerHTML;
      const checkIcon = '{{ "icon-check-mark.svg" | inline_asset_content | escape }}';

      button.querySelector('.social-share-icons__icon').innerHTML = checkIcon;
      button.style.backgroundColor = '#4caf50';
      button.style.borderColor = '#4caf50';
      button.style.color = 'white';

      setTimeout(() => {
        button.querySelector('.social-share-icons__icon').innerHTML = originalIcon;
        button.style.backgroundColor = '';
        button.style.borderColor = '';
        button.style.color = '';
      }, 2000);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
